import React from "react";
// import StaffIcon from "../../../assets/images/employee.png";
import StaffIcon from "../../../assets/icons/teacher.png";

// import TripIcon from "../../../assets/images/destination.png";
import TripIcon from "../../../assets/icons/trip-icon.png";

// import StudentIcon from "../../../assets/images/students.png";
import StudentIcon from "../../../assets/icons/student.png";

function ImagIcon(props) {
  const { display } = props;
  let Icon;
  switch (display) {
    case "Trips":
      Icon = TripIcon;
      break;
    case "Staffs":
      Icon = StaffIcon;
      break;
    case "Students":
      Icon = StudentIcon;
      break;
    default:
      Icon = StaffIcon;
  }
  return (
    <div className="ovv-imageIcons-container">
      <img
        className="ovv-imageIcon"
        width="40"
        height="40"
        src={Icon}
        alt="Top Statistics Logo"
      />
    </div>
  );
}

export default ImagIcon;
